import { render, staticRenderFns } from "./AiStatusPills.vue?vue&type=template&id=6077f200&scoped=true"
import script from "./AiStatusPills.vue?vue&type=script&lang=js"
export * from "./AiStatusPills.vue?vue&type=script&lang=js"
import style0 from "./AiStatusPills.vue?vue&type=style&index=0&id=6077f200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6077f200",
  null
  
)

export default component.exports